import { useTranslation } from "react-i18next";
import Button from "../Common/Button";

const SelectionBar = ({ selectedCount, maxCount, onSubmit, disabled = false }) => {
    const { t } = useTranslation();

    return (
        <div className="sticky bottom-4 mt-10 md:static">
            <Button
                type="button"
                onClick={onSubmit}
                disabled={disabled}
                className="w-full"
            >
                {t("PRODUCT_COLLECTIONS_SEND_GIFTS")} {selectedCount}/{maxCount}
            </Button>
        </div>
    );
};

export default SelectionBar;
